
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as _ref_QGpzLWpvZGEvY29yZQ_ from '@js-joda/core';
import * as _ref_aWRiLWtleXZhbA_ from 'idb-keyval';
import { instantiate } from './composeApp.uninstantiated.mjs';


const exports = (await instantiate({
    './skiko.mjs': Li9za2lrby5tanM,
    '@js-joda/core': _ref_QGpzLWpvZGEvY29yZQ_,
    'idb-keyval': _ref_aWRiLWtleXZhbA_
})).exports;

export const {
memory,
_initialize
} = exports


